import { Modal } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBlocker } from 'shared/hooks/use-blocker';

interface IProps {
  title?: string;
  message?: string;
  when: boolean;
}

export const ChangeFormValueModal: React.FC<IProps> = ({ title, message, when }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [lastLocation, setLastLocation] = useState<any>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const cancelNavigation = useCallback(() => {
    setShowModal(false);
    setLastLocation(null);
  }, []);

  const handleBlockedNavigation = useCallback(
    nextLocation => {
      if (!confirmedNavigation && nextLocation.location.pathname !== location.pathname) {
        setShowModal(true);
        setLastLocation(nextLocation);
        return false;
      }
      return true;
    },

    [confirmedNavigation, location],
  );

  const confirmNavigation = useCallback(() => {
    setShowModal(false);
    setConfirmedNavigation(true);
  }, []);

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      navigate(lastLocation.location?.pathname);

      setConfirmedNavigation(false);
    }
  }, [confirmedNavigation, lastLocation]);

  useBlocker(handleBlockedNavigation, when);

  return (
    <Modal
      forceRender={false}
      destroyOnClose
      open={showModal}
      onCancel={cancelNavigation}
      title={title || 'Вы действительно хотите уйти не сохранив данные?'}
      onOk={confirmNavigation}
      okText="Хорошо"
      cancelText="Отмена"
      closable={false}
    >
      <span>{message || 'Вы изменили данные, но не сохранили их, действительно хотите покинуть страницу?'}</span>
    </Modal>
  );
};
